export const Routes = {
  workflow: "/workflow",
  home: "/",
  // login: "/",
  createQueue: "/addQueue",
  Config: "/Configqueue/:id",
};
